import { AfterViewInit, Component, ComponentFactoryResolver, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { AthletesFormComponent } from '../form/form';
import { PopupContactAthleteFormComponent } from '../../pages/popup-contact/popup-contact';
import { CoachesProvider } from '../../../coaches/providers/coaches-provider';
import { AnnualPlanService } from '../../../annual-plan/providers/annual-plans.services';
import { AnnualPlanData } from '../../../annual-plan/merger/annual-plan-data-merger';
import { forkJoin, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from '../../../common/models/organization';
import { Athlete } from "../../../common/models/athlete";
import { Gender } from "../../../common/models/gender";
import { ContractType } from "../../../common/models/contract-type";
import { Coach } from "../../../common/models/coach";
import { Team } from "../../../common/models/team";
import { AthleteRow, AthletesProvider } from "../../providers/athletes-provider";
import { AnnualPlan } from "../../../common/models/annual-plan";
import { DiscussionModel } from "../../../common/models/discussion-model";
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { Snackbar } from "../../../common/snackbar/snackbar";
import { TeamsProvider } from "../../../teams/providers/teams-provider";
import { CurrentUser } from "../../../common/providers/current-user";
import { DiscussionService } from "../../../chat/discussion/discussion.service";
import { ParticipantModel } from "../../../common/models/participant-model";
import { ApiError } from "../../../common/error/api-error";
import { DiscussionComponent } from "../../../chat/discussion/discussion.component";
import { DefaultPipe } from "../../../common/pipes/default";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { NgIf } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButton, MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import {
  FeedbackAthleteSmileyComponent
} from "../../../feedback/components/athlete-smiley/feedback-athlete-smiley.component";
import { catchError, map } from "rxjs/operators";

@Component({
  selector: 'athlete-side-menu',
  providers: [],
  styleUrls: ['./side-menu.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    AppDatePipe,
    DefaultPipe,
    NgIf,
    MatTooltipModule,
    MatMiniFabButton,
    MatIcon,
    MatButton,
    RouterLink,
    FeedbackAthleteSmileyComponent,
  ],
  templateUrl: './side-menu.html'
})
export class AthleteSideMenuComponent implements AfterViewInit, OnDestroy {
    public organization: Organization = {} as Organization;
    public athlete: Athlete = {} as Athlete;
    public availableGenders: Gender[] = [];
    public availableContractTypes: ContractType[] = [];
    public availableCoaches: Coach[] = [];
    public availableTeams: Team[] = [];
    public viewedAthlete: AthleteRow = {} as AthleteRow;
    public activeAnnualPlan: AnnualPlan = {} as AnnualPlan;
    public discussions$: Observable<DiscussionModel[]> | undefined;
    public discussionLoading = false;

    public _viewedAthleteId = 0;
    private factoryResolver;
    private subscriptions: Subscription[] = [];
    constructor(
    @Inject(ComponentFactoryResolver) factoryResolver:any,
                                      public conf: ConfigProvider,
                                      public utils: UtilsProvider,
                                      private app: AppComponent,
                                      private _translater: TranslateService,
                                      private snackbar: Snackbar,
                                      private _toaster: MatSnackBar,
                                      private _route: ActivatedRoute,
                                      private router: Router,
                                      private _organizationNavigation: OrganizationsNavigationProvider,
                                      private _athletesProvider: AthletesProvider,
                                      private _currentUserRoles: CurrentUserRolesProvider,
                                      private _dialog: MatDialog,
                                      private _teamsProvider: TeamsProvider,
                                      private _coachesProvider: CoachesProvider,
                                      private _annualPlanProvider: AnnualPlanService,
                                      private _discussionService: DiscussionService,
                                      private _currentUser: CurrentUser,
                                      private discussionParticipantDialog: MatDialog,
    ) {
        this.factoryResolver = factoryResolver;
    }

    //

    public ngAfterViewInit() {
      this.subscriptions.push(this._route.params.pipe(
        switchMap(params => {
          this._viewedAthleteId = parseInt(params['athleteId'], 10);
          return this._organizationNavigation.getOrganisationFromRoute();
        }),
        switchMap(organization => {
          if (!organization) {
            throw new Error('Organization not found');
          }
          this.organization = organization;
          // Assume loadData returns Observable<void> and triggers additional loading
          return this.loadData();
        }),
        catchError(error => {
          console.error('Error in processing:', error);
          this.onError(error);
          return of(null); // Continue the observable chain even on error
        })
      ).subscribe({
        next: () => {
          this.loadAnnualPlan();
        },
        error: (error) => {
          console.error('Subscription error:', error);
          // Optionally handle stream errors here
        }
      }));
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public onMessageAthleteClicked(ath: AthleteRow): void {

        this.discussionLoading = true;

        // cherche mes chats
        this.discussions$ = this._discussionService.findAllByUser(this._currentUser.user!);
        this.subscriptions.push(
            this.discussions$.subscribe(
                (value) => {
                    if (value && value[0]){
                        const discussion: DiscussionModel = value[0];

                        const participants = discussion.participants;
                        const BreakException = {};
                        let discussionOpened = false;

                        try {
                            participants?.forEach((participant: ParticipantModel) => {

                                if (participant.user?.id === ath.user.id) {
                                    this.displayDiscussion(discussion);
                                    discussionOpened = true;
                                    throw BreakException;
                                }
                            });
                        } catch (e) {
                            if (e !== BreakException) {throw e; }
                        }

                        if (!discussionOpened){

                            // démarre une nouvelle discussion avec cet athlète
                            this._discussionService.save(this._currentUser.user!, this.organization!, [ath.user.id!], null).subscribe((discussion: DiscussionModel) => {
                                this.displayDiscussion(discussion);
                            }, (err: ApiError) => {
                                this.discussionLoading = false;
                                this._toaster.open(this._translater.instant('Chat_open_error'), '', { duration: 5000 });
                            });
                        }
                    }
                })
        );
    }

    public onGotoStatisticsClicked(ath: AthleteRow): void {
      if (!this.organization) throw new Error('Organization not found');
      if (!this.athlete) throw new Error('Athlete not found');
        this.router.navigateByUrl(`/${this.organization!.code}/athletes/${this.athlete.userId}/stats`);
    }

    public onContactInfoAthleteClicked(ath: AthleteRow): void {

        const dialogRef: any = this._dialog.open(PopupContactAthleteFormComponent, {
            data: {
                athleteRow: ath,
                formTitle: 'Athlete_Contact',
            }
        });
    }

    public onModifyAthleteClicked(toModify: AthleteRow): void {

        const dialogRef: any = this._dialog.open(AthletesFormComponent, {
            data: {
                organization: this.organization,
                availableGenders: this.availableGenders,
                availableContractTypes: this.availableContractTypes,
                availableCoaches: this.availableCoaches,
                availableTeams: this.availableTeams,
                athleteRow: toModify,
                formTitle: 'Athlete_edition',
                confirmButtonTitle: this._translater.instant('Save')
            }
        });

        // màj de la liste
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((ath: AthleteRow) => {
                if (ath) {
                    this.viewedAthlete = ath;
                }
            })
        );
    }

    private displayDiscussion(discussion: DiscussionModel) {

        const ref = this.app.getChatDiscussionRef();
        const componentFactory = this.factoryResolver.resolveComponentFactory(DiscussionComponent);

        if(!ref) throw new Error('Discussion reference not found');
        ref.clear();
        const componentRef = ref.createComponent(componentFactory, undefined, ref.injector);
        const component = componentRef.instance as DiscussionComponent;
        component.viewRef = componentRef;
        component.discussion = discussion;

        this.discussionLoading = false;
    }

    private loadData(): Observable<any> {
      return forkJoin([
        this._athletesProvider.getAthleteRow(this.organization.id!, this._viewedAthleteId),
        this._athletesProvider.getGenders().pipe(catchError(() => of([]))),
        this._athletesProvider.getContractTypes().pipe(catchError(() => of([]))),
        this._teamsProvider.getTeams({organizationId: this.organization.id!}).pipe(catchError(() => of([]))),
      ]).pipe(
        switchMap(([athleteUser, genders, contractTypes, teams] : [AthleteRow, Gender[], ContractType[], Team[]]) => {
          this.viewedAthlete = athleteUser;
          if (!this.viewedAthlete) throw new Error('Athlete not found');
          this.athlete = this.viewedAthlete?.athlete!;
          this.availableGenders = genders;
          this.availableContractTypes = contractTypes;
          this.availableTeams = teams;

          return of(null);
        })
      );
    }

    private loadAnnualPlan() {
        this.subscriptions.push(
            this._annualPlanProvider.findActiveByAthleteUserId(this.organization, this._viewedAthleteId, true).subscribe((data: AnnualPlanData) => {
                this.activeAnnualPlan = data['plan'];
            })
        );
    }

    private onError(error: any): void {
      console.error("Side menu : ", error);
    }
}
